import { createActionGroup, emptyProps } from '@ngrx/store';
import {
  ChangeSubscriptionRequest,
  ContractResponse,
  InvoiceCallDetailsResponse,
  InvoiceInternetDetailsResponse,
  MsisdnSubscriptionDetails,
  SubscriptionAvailabilityResponse,
  SubscriptionResponse,
  WalletResponse,
} from '@core/contracts/data-contracts';
import { CallSmsUsageViewModel, InternetUsageViewModel } from '@core/models';

export const SubscriptionActions = createActionGroup({
  source: 'Subscription',
  events: {
    'Get Current Subscription': emptyProps(),
    'Get Current Subscription Success': (subscription: SubscriptionResponse) => ({
      subscription,
    }),
    'Get Current Subscription Failure': emptyProps(),
    'Get Contract Details': emptyProps(),
    'Get Contract Details Success': (contract: ContractResponse) => ({
      contract,
    }),
    'Get Contract Details Failure': emptyProps(),
    'Get Costs Details': emptyProps(),
    'Get Costs Details Success': (costs: MsisdnSubscriptionDetails[], totalPrice: number) => ({
      costs,
      totalPrice,
    }),
    'Get Costs Details Failure': emptyProps(),

    'Get Internet Usage Details': (monthIndex: number, isOnlyExtra: boolean) => ({
      monthIndex,
      isOnlyExtra,
    }),
    'Get Internet Usage Details Success': (internetUsage: InternetUsageViewModel) => ({
      internetUsage,
    }),
    'Get Internet Usage Details Failure': emptyProps(),

    'Get CallSms Usage Details': (monthIndex: number, isOnlyExtra: boolean) => ({
      monthIndex,
      isOnlyExtra,
    }),
    'Get CallSms Usage Details Success': (callSmsUsage: CallSmsUsageViewModel) => ({
      callSmsUsage,
    }),
    'Get CallSms Usage Details Failure': emptyProps(),

    'Get Bundles': emptyProps(),
    'Get Bundles Success': (bundles: SubscriptionAvailabilityResponse) => ({
      bundles,
    }),
    'Get Bundles Failure': emptyProps(),

    'Get Wallet': emptyProps(),
    'Get Wallet Success': (wallet: WalletResponse) => ({
      wallet,
    }),
    'Get Wallet Failure': emptyProps(),

    'Topup Wallet': (amount: number) => ({ amount }),
    'Topup Wallet Success': (url: string) => ({
      url,
    }),
    'Topup Wallet Failure': emptyProps(),

    'Topup Extra Bundle': (bundleId: number, isRoaming: boolean = false) => ({
      bundleId,
      isRoaming,
    }),
    'Topup Extra Bundle Success': (bundleId: number, url: string) => ({
      bundleId,
      url,
    }),
    'Topup Extra Bundle Failure': emptyProps(),

    'Clear Wallet Topup Url': emptyProps(),

    'Get Wallet Internet Usage': (from: Date, to: Date, sortType: string) => ({
      from,
      to,
      sortType,
    }),
    'Get Wallet Internet Usage Success': (internetUsage: InvoiceInternetDetailsResponse) => ({
      internetUsage,
    }),
    'Get Wallet Internet Usage Failure': emptyProps(),

    'Get Wallet Voice Usage': (from: Date, to: Date, sortType: string) => ({
      from,
      to,
      sortType,
    }),
    'Get Wallet Voice Usage Success': (callSmsUsage: InvoiceCallDetailsResponse) => ({
      callSmsUsage,
    }),
    'Get Wallet Voice Usage Failure': emptyProps(),

    'Is Sticky Element Visible': (isStickyElementVisible: boolean) => ({ isStickyElementVisible }),
    'is Sticky Element Visible Success': emptyProps(),
    'is Sticky Element Visible Failure': emptyProps(),

    'Update Subscription': (body: ChangeSubscriptionRequest) => ({ body }),
    'Update Subscription Success': emptyProps(),
    'Update Subscription Failure': emptyProps(),
    'Clear Update Subscription Status': emptyProps(),

    'Download Usage Overview': (from: Date, to: Date, isToggleOn: boolean) => ({
      from,
      to,
      isToggleOn,
    }),
    'Download Usage Overview Success': emptyProps(),
    'Download Usage Overview Failure': emptyProps(),

    'Download Wallet Usage Overview': (from: Date, to: Date) => ({
      from,
      to,
    }),
    'Download Wallet Usage Overview Success': emptyProps(),
    'Download Wallet Usage Overview Failure': emptyProps(),

    'Download Contract': emptyProps(),
    'Download Contract Success': emptyProps(),
    'Download Contract Failure': emptyProps(),

    'Download Costs': emptyProps(),
    'Download Costs Success': emptyProps(),
    'Download Costs Failure': emptyProps(),
  },
});
